import { FC } from 'react';
import s from './style.module.css';

export const H: FC<{ isMobile?: boolean }> = ({ children, isMobile }) => {
  return <div className={isMobile ? s.hMobile : s.h}>{children}</div>;
};
